<!-- @ts-nocheck -->
<template>
  <q-select
    v-bind="$attrs"
    :modelValue="selectedOptions"
    :stack-label="!dense"
    use-input
    :hide-selected="multiple !== ''"
    fill-input
    filled
    emit-value
    :clearable="!disabled"
    :dense="ldense"
    input-debounce="0"
    option-value="value"
    option-label="label"
    :multiple="multiple == ''"
    :use-chips="multiple == ''"
    ref="IstFormSearch"
    :options="curOptions"
    :disabled="disabled"
    :disable="disabled"
    :readonly="disabled"
    :label="getLabel()"
    :error="disabled ? false : error"
    :error-message="disabled ? '' : errorMessage"
    :class="{ showerror: error }"
    :loading="loading"
    style="padding-bottom: 0"
    autocomplete="off"
    autocorrect="off"
    autocapitalize="off"
    spellcheck="false"
    @update:modelValue="
      localvalue = $event;
      updateValue();
    "
    :input-style="inputStyle"
    @filter="defaultfilter"
  >
    <slot v-for="(_, name) in $slots" :name="name" />
    <template v-slot:option="scope">
      <q-item v-bind="scope.itemProps" @click="userInteracted">
        <q-item-section>
          <q-item-label>
            {{ scope.opt.label }}<q-icon v-if="scope.opt.hidden" name="mdi-eye-off"
          /></q-item-label>
          <q-item-label v-if="scope.opt.sublabel" caption>{{ scope.opt.sublabel }}</q-item-label>
        </q-item-section>
      </q-item>
    </template>

    <template v-slot:no-option>
      <q-item>
        <q-item-section class="text-italic text-grey">{{ noOptionsText }}</q-item-section>
      </q-item>
    </template>
  </q-select>
</template>
<script lang="ts">
// @ts-nocheck
import { Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { QSelect } from "quasar";
import { searchPredicate } from "../utils/searchUtils";

export type optiontype = {
  label: string;
  sublabel: string; //todo
  value: any;
  icon: string; //todo
};

export default class App extends Vue {
  name = "IstFormSearch";
  ldense = false;

  @Prop()
  validation!: any;
  @Prop({ default: null, type: [String, Number, Object] })
  readonly modelValue!: any;
  @Prop()
  disabled!: boolean;
  @Prop()
  label!: string;
  @Prop()
  options!: Array<optiontype>;
  @Prop({ default: false })
  error!: boolean;
  @Prop({ default: false, type: [Boolean, String] })
  dense!: boolean | string;
  @Prop()
  errorMessage!: string;
  @Prop({ default: "false" })
  multiple!: string;
  @Prop()
  inputStyle!: any;
  @Prop({ default: false })
  loading!: boolean;

  @Prop({ default: "Der er ingen valgmuligheder der matcher det indtastede" })
  noOptionsText!: string;

  @Emit("input")
  @Emit("change")
  @Emit("update:modelValue")
  updateValue() {
    this.$emit("input", this.localvalue);
    this.$emit("change", this.localvalue);
    this.$emit("update:modelValue", this.localvalue);
    return this.localvalue;
  }

  @Watch("modelValue")
  @Watch("value")
  onValueChanged(val: any) {
    if (val) {
      try {
        this.localvalue = val;
      } catch (e) {
        this.localvalue = undefined;
      }
    } else {
      this.localvalue = undefined;
    }
  }

  mounted() {
    this.curOptions = this.options;
    if (this.modelValue) {
      this.localvalue = this.modelValue;
    }
    this.ldense = (typeof this.dense === "boolean" && this.dense) || this.dense == "true";
  }

  public get selectedOptions(): any {
    if (this.multiple === "") {
      if (this.localvalue) {
        return this.options.filter((value: optiontype) => {
          return this.localvalue.some((localVal) => this.objectComparer(localVal, value.value));
        });
      }
      return [];
    } else {
      return this.options.find((value: optiontype) => this.localvalue == value.value);
    }
  }

  public set selectedOptions(selection: any) {
    if (this.multiple === "") {
      if (Array.isArray(selection)) {
        this.localvalue = selection.map((value: optiontype) => value.value);
      } else {
        this.localvalue = null;
      }
      (this.$refs.IstFormSearch as QSelect).updateInputValue("", false);
    } else {
      this.localvalue = selection.value;
    }
    this.updateValue();
  }

  objectComparer(obj1, obj2) {
    if (obj1.equals && obj2.equals) {
      // both objects have a built in equals method, using it
      return obj1.equals(obj2) && obj2.equals(obj1);
    }

    const obj1Keys = Object.keys(obj1);
    const obj2Keys = Object.keys(obj2);

    if (obj1Keys.length !== obj2Keys.length) {
      return false;
    }

    for (const key of obj1Keys) {
      const obj1Val = obj1[key];
      const obj2Val = obj2[key];

      if (obj1Val === undefined) {
        if (obj2Val !== undefined) {
          return false;
        }
      }

      if (obj1Val !== obj2Val) {
        return false;
      }
    }
    return true;
  }

  curOptions: Array<optiontype> = [];
  localvalue: any = null;

  getLabel() {
    if (!this.label) {
      return null;
    }
    let s: string = this.label.charAt(0).toUpperCase() + this.label.substring(1).toLowerCase();

    if (this.validation) {
      s += this.validation.required !== undefined ? " *" : "";
    }
    return s;
  }

  defaultfilter(val: string, update: (callbackFn) => void) {
    update(() => {
      this.curOptions = this.options.filter((v) => searchPredicate(val.toLowerCase(), v.label));
    });
  }

  focus() {
    (this.$refs.IstFormSearch as QSelect).focus();
  }
}
</script>
<style scoped>
.showerror {
  padding-bottom: 20px !important;
}
</style>
